import LearnMore from "../LearnMore";
import store from "../../store/configureStore";
import stringToHash from "../../data/dataUtils";

class LearnMoreBuilder {
  static buildLearnMore(id, informationChunks, titleHash, subrightID) {
    if (
      id == null ||
      informationChunks == null ||
      titleHash == null ||
      subrightID == null
    ) {
      return null;
    }

    if (
      typeof id !== "string" ||
      !Array.isArray(informationChunks) ||
      typeof titleHash !== "string" ||
      typeof subrightID !== "string"
    ) {
      return null;
    }

    const translationMap = store.getState().rights.translationMap;
    if (!translationMap.hasOwnProperty(titleHash)) {
      // * I added this to load missing modules that showed up on the mobile app but not in the desktop editor TT
      titleHash = stringToHash("");
      // return null;
    }
    const infoChunks = informationChunks ? informationChunks : [];
    const chunksWoutHashes =
      this.#getInformationChunksWithoutHashes(infoChunks);
    const title = translationMap[titleHash];

    return new LearnMore(
      id,
      infoChunks,
      chunksWoutHashes,
      title,
      titleHash,
      subrightID
    );
  }

  static #getInformationChunksWithoutHashes(informationChunks) {
    const translationMap = store.getState().rights.translationMap;
    let infoChunksCopy = [];
    informationChunks.forEach((elem) => {
      const chunkCopy = { ...elem };
      infoChunksCopy.push(chunkCopy);
    });
    for (var elem in infoChunksCopy) {
      for (var chunk in infoChunksCopy[elem]) {
        let chunkHash = infoChunksCopy[elem][chunk];
        infoChunksCopy[elem][chunk] =
          chunkHash === 0 ? "" : translationMap[chunkHash];
      }
    }
    return infoChunksCopy;
  }
}

export default LearnMoreBuilder;
